<template>
<div>
  <span v-if="counter.hits !== -1" class="font-weight-bold bluetext">{{ $t('HITLIST_COUNTER', { counter: counter.hits }) }} <span v-if="counter.totalHits">/</span> {{ counter.totalHits }} </span>
  <span v-if="counter.totalHitsAppendix">{{counter.totalHitsAppendix}}</span>
  <span v-if="counter.pgCnt !== -1 && (counter.pgCnt + '') !== ''" class="font-weight-bold bluetext">&nbsp;&nbsp;{{ $t('LABEL_PEERGROUP_CNT')}} {{counter.pgCnt}}</span>
</div>
</template>

<script>
import Vue from "vue";

export default {
  name: 'HitlistCounter',
  data () {
    return {
      counter: {
        hits: -1,
        pgCnt: -1,
        totalHist: -1,
        totalHitsAppendix: ''
      }
    }
  },
  methods: {
    onGetCounter (counter) {
      this.counter = counter
      var peergroup = Vue.prototype.storage.getPeergroup(Vue.prototype.$api.getModuleId());
      if (peergroup !== undefined && peergroup !== null) {
        this.counter.pgCnt = peergroup.length
      } else {
        this.counter.pgCnt = -1
      }

    }
  },
  created () {
    Vue.prototype.$eventHub.$on('hitlistcounter', this.onGetCounter)
  },
  destroyed () {
    Vue.prototype.$eventHub.$off('hitlistcounter', this.onGetCounter)
  },
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/HitlistCounter.vue